import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 16 16',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g fill={fill}>
      <path d="M12.13,2.3A7.07,7.07,0,0,1,9.08,3a7.07,7.07,0,0,1-3-.67s0,0,0,0A3.52,3.52,0,0,0,4.54,2a3.49,3.49,0,0,0-2.39.95l4,6A3.49,3.49,0,0,1,8.57,8a3.54,3.54,0,0,1,1.52.34l.09,0A7,7,0,0,0,13.11,9,7.07,7.07,0,0,0,16,8.38Z" />
      <path d="M.88,2.85,0,3.4,7.82,14.95l.06.1L8,15l.74-.49Z" />
    </g>
  </svg>
);
export default SVG;
